import queryString from 'query-string';
import API from '../constants/api';

export const fetchRubrics = fetch =>
  fetch(API.JOURNAL.RUBRICS())
    .then(r => (r.ok ? r.json() : []))
    .then(rubrics => rubrics.filter(rubric => !rubric.hidden));

export const fetchModels = (fetch, transport, make) =>
  fetch(`${API.ADVERT.MODELS_COUNT}?${queryString.stringify({ transport, make })}`).then(r =>
    r.json(),
  );

export const fetchGenerations = (fetch, modelId) =>
  fetch(API.CMM.generationsByModel(modelId)).then(r => r.json());

export const fetchNews = ({ fetch, ...params }) =>
  fetch(API.JOURNAL.LIST(params)).then(r => r.json());

export const getModels = async (makeId = false, prefSearch = false, _this) => {
  const transport = 1;
  const { fetch, videoFilters } = _this.props;
  const { model } = prefSearch && videoFilters;

  const models = await (makeId && fetchModels(fetch, transport, makeId));
  // if makeId not selected we getting all videos
  if (models) _this.setState({ models });
  if (model && models) _this.handleModelChange(model, prefSearch);
};

export const getGenerations = async (modelId = false, prefSearch = false, _this) => {
  const { fetch, videoFilters } = _this.props;
  const { generation } = prefSearch && videoFilters;

  const generations = await (modelId && fetchGenerations(fetch, modelId));

  if (generations) _this.setState({ generations });
  if (generation && generations) _this.handleGenerChange(generation, prefSearch);
};

export const sortVideo = async (sortRequest, setNews) => {
  const videos = await fetchNews(sortRequest);
  setNews((videos && videos.results) || []);
};



// WEBPACK FOOTER //
// ./src/shared/network/journal.js